export function mapWalletData(
  data: NFTAsset[],
  overrideData: { collectionAddress: string; tokenId: number }[] | null
): NFTAsset[] {
  const returnArr: NFTAsset[] = data;
  if (overrideData) {
    for (const item of overrideData) {
      let collectionName = "Cryptopunks";
      if (
        item.collectionAddress === "0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d"
      )
        collectionName = "BoredApeYachtClub";
      returnArr.push({
        imageUrl: "",
        //@ts-ignore
        temporary: true,
        openseaRefreshed: true,
        revealed: true,
        originalImageUrl: "",
        tokenMetadata: "",
        tokenId: item.tokenId,
        _id: Number(item.tokenId),
        contractAddress: item.collectionAddress.toLowerCase(),
        collectionName: collectionName,
      });
    }
  }
  return returnArr;
}

// imageUrl: "https://lh3.googleusercontent.com/lCQ3OZF_3JuMMgDZyhtNjNXzcYSQbeLOo4vhRjaKEgAqFsbqc2lCtqiKByyjp-vakx5ZdlxrUtXdyMQ9CMskrPurc_QdSWEBwTme4Q"
// openseaRefreshed: true
// originalImageUrl: "ipfs://QmSg9bPzW9anFYc3wWU5KnvymwkxQTpmqcRSfYj7UmiBa7"
// revealed: true
// tokenId: 4
// tokenMetadata: "https://opensea.mypinata.cloud/ipfs/QmeSjSinHpPnmXmspMjwiXyN6zS4E9zccariGR3jxcaWtq/4"
// _id: 4

export interface RobotData {
  _id: number;
  imageUrl: string;
  tokenId: number;
  originalImageUrl?: string;
  tokenMetadata?: string;
  revealed?: boolean;
  openseaRefreshed: true;
  contractAddress: string;
  name: string | null;
}
export interface NFTAsset {
  _id: number | string;
  imageUrl: string;
  tokenId: number | string;
  originalImageUrl: string;
  tokenMetadata: string;
  revealed: true;
  openseaRefreshed: true;
  contractAddress: string;
  collectionName: string;
}

export interface WalletContentsData {
  data: NFTAsset[];
  success: boolean;
}
export interface ItemsEntity {
  name: string | undefined | null;
  contract_decimals: number;
  contract_name: string;
  contract_ticker_symbol?: string | null;
  contract_address: string;
  supports_erc?: (string | null)[] | null;
  logo_url: string;
  last_transferred_at?: string | null;
  type: string;
  balance?: string | null;
  balance_24h?: string | null;
  quote_rate?: number | null;
  quote_rate_24h?: number | null;
  quote: number;
  quote_24h?: number | null;
  nft_data?: (NftDataEntity | null)[] | null;
}
export interface NftDataEntity {
  token_id: string;
  token_balance: string;
  token_url: string;
  supports_erc?: string[] | null;
  token_price_wei?: null;
  token_quote_rate_eth?: null;
  original_owner: string;
  external_data: ExternalData;
  owner?: string | null;
  owner_address?: null;
  burned?: null;
}
export interface ExternalData {
  name: string;
  description?: string | null;
  image: string;
  image_256: string;
  image_512: string;
  image_1024: string;
  animation_url?: string | null;
  external_url?: string | null;
  attributes?: Attributes | Entity[] | null;
  owner?: null;
}
export interface Attributes {
  character: string;
  mask: string;
  eye_color: string;
  skin_color: string;
  item: string;
}
export interface Entity {
  trait_type: string;
  value: string | number | boolean;
}
